import { Paper, styled as materialStyled } from "@material-ui/core";
import React, { ComponentProps, FunctionComponent } from "react";
import styled from "styled-components";
import { device } from "../../styles/media";
import { Flex } from "../layout";

export const WIDGET_MOBILE_PADDING = "1.5em";
export const WIDGET_DESKTOP_PADDING = "2em";
export const WIDGET_BORDER_RADIUS = "5px";

const CustomMaterialWidget = materialStyled(Paper)((propsAndTheme) => {
  return {
    cursor: (propsAndTheme as any).onClick ? "pointer" : undefined,
    padding: WIDGET_MOBILE_PADDING,
    borderRadius: WIDGET_BORDER_RADIUS,
    boxShadow:
      "0px 17px 41px rgba(79, 115, 255, 0.08), 0px 2.12866px 5.13384px rgba(79, 115, 255, 0.04)",

    [`@media ${device.laptop}`]: {
      padding: WIDGET_DESKTOP_PADDING,
    },
  };
});

export type WidgetProps = Omit<
  React.ComponentProps<typeof CustomMaterialWidget>,
  "title"
> & {
  title?: React.ReactNode;
  adornment?: React.ReactNode;
};

const Title = styled.h2`
  margin: 0;
  font-family: "Helvetica Neue", sans-serif;
`;

const Header = styled(Flex)`
  margin-bottom: 2em;
  justify-content: space-between;
`;

const AdornmentWrapper = styled.div`
  margin-left: 3em;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`;

export const Widget: React.FunctionComponent<
  WidgetProps &
    Omit<ComponentProps<typeof Paper>, "title" | "adornment" | "children">
> = (props) => {
  const { title, adornment, children, ...propsToPass } = props;

  return (
    <CustomMaterialWidget {...propsToPass}>
      {title || adornment ? (
        <Header>
          {title ? <Title className="h2">{title}</Title> : null}
          {adornment ? <AdornmentWrapper>{adornment}</AdornmentWrapper> : null}
        </Header>
      ) : null}
      {children}
    </CustomMaterialWidget>
  );
};

const OutlineMaterialWidget = materialStyled(Paper)({
  padding: WIDGET_MOBILE_PADDING,
  borderRadius: WIDGET_BORDER_RADIUS,
  border: "2px solid black",
  position: "relative",
  // boxShadow:
  //   "0px 17px 41px rgba(79, 115, 255, 0.08), 0px 2.12866px 5.13384px rgba(79, 115, 255, 0.04)",

  // [`@media ${device.laptop}`]: {
  //   padding: WIDGET_DESKTOP_PADDING,
  // },
});

const OutlineTitle = styled.h2``;

export const OutlineWidget: FunctionComponent<{
  title?: string;
}> = ({ title, children }) => (
  <OutlineMaterialWidget>
    {title ? <OutlineTitle>{title}</OutlineTitle> : null}
    {children}
  </OutlineMaterialWidget>
);
